import { render, staticRenderFns } from "./GlobalActivityFeed.vue?vue&type=template&id=50ea6f08"
import script from "./GlobalActivityFeed.vue?vue&type=script&lang=js"
export * from "./GlobalActivityFeed.vue?vue&type=script&lang=js"
import style0 from "./GlobalActivityFeed.vue?vue&type=style&index=0&id=50ea6f08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports